import Medusa from '@adoratorio/medusa';

import { animations } from '@/assets/animations';

require('intersection-observer');

const medusa = {
  ref: null,
  init: () => {
    medusa.ref = new Medusa({
      targets: []
    });
  },
}

export default medusa;
